var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-list__item photo-item"},[_c('img',{staticClass:"photo-item__img",attrs:{"src":((_vm.image.src) + "&auto=format&w=1024&h=952&q=70"),"alt":_vm.image.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }